<template>
  <div class="videos-item" @click="goToVideo(video.id)">
    <div class="videos-item__content">
      <div class="videos-item__title">
        {{ video.title }}
      </div>
      <chip-label class="videos-item__published_at">Dodano {{ video.publishedAt }}</chip-label>
    </div>
  </div>
</template>

<script>
  import ChipLabel from './ChipLabel';

  import { DEFAULT_THUMBNAIL } from '../config/general.config';

  export default {
    name: 'VideosItem',
    components: {
      ChipLabel,
    },
    props: {
      poster: {
        type: String,
        default: DEFAULT_THUMBNAIL,
      },

      video: {
        type: Object,
        default: () => ({}),
      },
    },
    methods: {
      goToVideo(id) {
        this.$router.push({ name: 'video', params: { id } });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .videos-item {
    $item: &;
    margin-bottom: 10px;
    padding: 15px;
    cursor: pointer;
    position: relative;
    width: 100%;

    &__title {
      @include fontSize(18px);
      font-weight: bold;
      position: relative;
      min-height: 48px;
      display: flex;
      justify-content: center;
      align-content: center;
      flex-direction: column;
      transition: all ease-in 0.2s;
    }

    &__content {
      padding-bottom: 15px;
      width: 100%;
    }

    &:not(&:last-of-type) {
      #{$item}__content {
        border-bottom: 1px solid #c8c8c8;
      }
    }

    &:hover {
      #{$item}__title {
        color: $color--red;
        @at-root .high-contrast & {
          color: yellow;
        }
      }
    }

    &__published_at {
      @at-root .high-contrast & {
        background-color: yellow;
        color: black;
      }
    }
  }
</style>
